// extracted by mini-css-extract-plugin
export default {"wrapper":"HotelGroup_wrapper__RlEEY","title":"HotelGroup_title__xCow3","bubble":"HotelGroup_bubble__GeQga"};